// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import Swiper from 'swiper/bundle';

'use strict';

// Calculate fixed header height and offset the page content
const header_height = $('header').outerHeight(true);
const pre_header_height = $('.header-pre-wrapper').outerHeight(true);
$('.main-content').css('margin-top', +header_height + 'px');

function isInView(elem) {
  return (
    $(elem).offset().top - $(window).scrollTop() < $(elem).height() + 450
  );
}

if ($(window).width() > 992) {
  $("ul.sub-menu").each(function () {
    const menuWidth = $(this).outerWidth(true);
    const leftAmount = (menuWidth / 2);
    $(this).css('margin-left', '-' + leftAmount + 'px')
  });
}

if ($('.front-swiper-container .swiper-slide').length > 1) {
  const front_swiper = new Swiper('.front-swiper-container', {
    autoplay: {
      delay: 5000
    },
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 1000,
    draggable: true,
    pagination: {
      el: '.swiper-pagination-front',
      clickable: true,
      type: 'bullets'
    },
    loop: true,
  });
}

if ($('.review-swiper-container .swiper-slide').length > 1) {
  const review_swiper = new Swiper('.review-swiper-container', {
    autoplay: {
      delay: 5000
    },
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 25,
    draggable: true,
    loop: true,
    navigation: {
      nextEl: '.review-swiper-button-next',
    },
    pagination: {
      el: '.review-swiper-pagination',
      clickable: true,
      type: 'bullets'
    },
    breakpoints: {
      576: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 1
      }
    }
  });
}

const partners_swiper = new Swiper('.partners-swiper-container', {
  autoplay: {
    delay: 2000
  },
  direction: 'horizontal',
  centeredSlides: true,
  slidesPerView: 1,
  speed: 1000,
  spaceBetween: 5,
  draggable: true,
  loop: true,
  breakpoints: {
    576: {
      slidesPerView: 3,
      spaceBetween: 25
    },
    768: {
      slidesPerView: 4
    },
    992: {
      slidesPerView: 5
    }
  }
});

const gallery_swiper = new Swiper('.gallery-swiper-container', {
  direction: 'horizontal',
  slidesPerView: 3,
  speed: 1000,
  draggable: true,
  centeredSlides: false,
  spaceBetween: 10,
  pagination: {
    el: '.swiper-pagination-gallery',
    clickable: true,
    type: 'bullets'
  },
  navigation: {
    prevEl: '.gallery-swiper-button-prev',
    nextEl: '.gallery-swiper-button-next',
  },
  loop: false
});

$(document).ready(function () {

  $('.hamburger').click(function () {
    $('.header__nav').toggleClass('is-active');
    $('body').toggleClass('is-active');
    $(this).toggleClass('is-active');
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() >= 50) { // this refers to window
      $('header').css('transform', 'translateY(-' + pre_header_height + 'px)');
    }
    else {
      $('header').css('transform', 'translateY(0)');
    }
  });

  $(window).on("scroll", function () {
    $(".animate").each(function () {
      if (isInView($(this))) {
        $(this).addClass("in-viewport");
      }
      else {
        $(this).removeClass("in-viewport");
      }
    });
  });

  $('.schilderwerk-file').change(function () {
    var file = $('.schilderwerk-file')[0].files[0].name;
    $('.attach-schilderwerk .schilderwerk-span').text(file);
  });

  $('.attach-schilderwerk').on('click', function () {
    $('.schilderwerk-file').val(null);
  });

  var ppp = 3; // Post per page
  var pageNumber = 1;

  $("#more_posts").click(function (e) {
    e.preventDefault();
    var catID = $('#portfolio').data("category");
    var dataType = $('#portfolio').data("type");
    console.log(catID);

    pageNumber++;
    var str = '&dataType=' + dataType + '&catID=' + catID + '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_post_ajax';
    $.post({
      url: ajax_posts.ajaxurl,
      data: str,
      type: 'POST',
      success: function (data) {
        var $data = $(data);
        if ($data.length) {
          $(".post-wrapper").append($data);
          $("#more_posts").attr("disabled", false);
        }
        else{
          $("#more_posts").remove();
          if ( dataType === 'project' ){
            $(".post-show-more").append('<p>Dit zijn momenteel al onze projecten, kunnen we deze lijst met jouw project aanvullen?</p><p><a class="btn btn--primary btn--svg-after btn--arrow" href="/contact">Neem contact op</a></p>');
          }
          else {
            $(".post-show-more").append('<p>Dit zijn momenteel al onze berichten. Vragen? Wij horen het graag!</p><p><a class="btn btn--primary btn--svg-after btn--arrow" href="/contact">Neem contact op</a></p>');
          }
        }
      },
    });
    return false;

  });

  $('.ba-slider__before').click(function(){
    $(this).removeClass('to-right').addClass('to-left');
    $('.ba-slider__after').removeClass('to-right').addClass('to-left');
    $('.image-before').removeClass('to-right').addClass('to-left');
  });

  $('.ba-slider__after').click(function(){
    $(this).removeClass('to-left').addClass('to-right');
    $('.ba-slider__before').removeClass('to-left').addClass('to-right');
    $('.image-before').removeClass('to-left').addClass('to-right');
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js